// extracted by mini-css-extract-plugin
export default {"image":"c8-z","loaded":"d8-z","placeholder":"e8-z"};